import {useState, useEffect} from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import routes from "routes.js";
import {withTranslation} from "react-i18next";
import "./Admin.scss";
import NavbarLogin from "components/Header/Navbars/NavbarLogin";
import NavbarBack from "components/Header/Navbars/NavbarBack";
import {useSelector, useDispatch} from "react-redux";

import {authActions} from "../_actions";
import Footer from "../components/Footer/footer";
import RotateDevice from "../components/RotateDevice/RotateDevice";
import localOrSessionStore from "../_helpers/localOrSessionStore";
import variables from "../_constants/variables";
import {xcService} from "../_services/xcService";

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} exact={prop?.exact} />;
      }
      return null;
    })}
    <Redirect from="/auth" to="/auth/login" />
  </Switch>
);

function Admin({...rest}) {
  const dispatch = useDispatch();
  const storage = localOrSessionStore({key: variables.REMEMBER});
  const userType = storage.getItem(variables.USER_TYPE);
  const [currentCount, setCount] = useState(1);
  var actualYear = useSelector((state) => state.authReducer.actualYear);

  useEffect(() => {
    if (currentCount <= 0) {
      return;
    }

    const id = setInterval(timer, 5 * 60000);
    return () => clearInterval(id);
  }, [currentCount]);

  const timer = () => {
    if (userType === "STUDENT") {
      xcService.putToken("/v1/minutes").then(() => {});
      setCount(currentCount + 1);
    }
  };

  useEffect(() => {
    if (!actualYear) {
      dispatch(authActions.actualYear());
    }
  }, []);

  return (
    <div className={"defaultBack admin-layout"}>
      {(rest.location.pathname.includes("informes") ||
        (!rest.location.pathname.includes("ceiba") &&
          !rest.location.pathname.includes("xcelence") &&
          !rest.location.pathname.includes("assessment") &&
          !rest.location.pathname.includes("cervo") &&
          !rest.location.pathname.includes("nogam") &&
          !rest.location.pathname.includes("tek"))) && <NavbarLogin className="menuNavAdmin" />}
      {(rest.location.pathname.includes("informes") ||
        (!rest.location.pathname.includes("ceiba") &&
          !rest.location.pathname.includes("xcelence") &&
          !rest.location.pathname.includes("assessment") &&
          !rest.location.pathname.includes("cervo") &&
          !rest.location.pathname.includes("nogam") &&
          !rest.location.pathname.includes("tek"))) && <NavbarBack current={rest.location.pathname} />}
      {switchRoutes}
      {(rest.location.pathname.includes("informes") ||
        (!rest.location.pathname.includes("ceiba") &&
          !rest.location.pathname.includes("xcelence") &&
          !rest.location.pathname.includes("assessment") &&
          !rest.location.pathname.includes("cervo") &&
          !rest.location.pathname.includes("nogam") &&
          !rest.location.pathname.includes("tek"))) && <Footer className="footer-admin" />}
      {(rest.location.pathname.includes("ceiba") ||
        rest.location.pathname.includes("xcelence") ||
        rest.location.pathname.includes("assessment") ||
        rest.location.pathname.includes("cervo") ||
        rest.location.pathname.includes("nogam") ||
        rest.location.pathname.includes("tek")) && <RotateDevice />}
    </div>
  );
}
export default withTranslation()(Admin);
